import { ChangeDetectorRef, Component , ElementRef, HostListener, Inject, Renderer2, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import config from 'config/default.json';

@Component({
  selector: 'app-raw-setting',
  templateUrl: './raw-setting.component.html',
  styleUrls: ['./raw-setting.component.scss']
})
export class RawSettingComponent {
  constructor(
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    public dialogRef: MatDialogRef<RawSettingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { [x:string]: any }
    ) {}
  userControl = new FormControl();
  actionControl = new FormControl();
  userInputControl = new FormControl();
  projectNameControl = new FormControl();
  rowInfos: { [x:string]: any } = this.data['row_infos'];
  userInfos: { [x:string]: any } = this.data['user_infos'];
  selectedRows: any[] = this.data['selected_rows'];
  platformInfos: { [x:string]: any } = this.data['platform_infos'];
  projectName: string = this.data?.['product_name'] ?? '';
  actionMode = 'create_project';

  ngOnInit(){
    this.actionControl.setValue('create_project');
    this.projectNameControl.setValue(this.projectName);
  }
  applyAction(){
    let action = this.actionControl.value;
    this.projectName = this.projectNameControl.value;
    if(action == 'create_project'){
      const firstSelect = this.selectedRows[0];
      let checkSameGroup = this.platformInfos['origin'] == 'virtualcampus'? (this.selectedRows as any[]).every(el => el.id_structure === firstSelect.id_structure):
                          (this.selectedRows as any[]).every(el => el.id_country === firstSelect.id_country && el.id_cycle === firstSelect.id_cycle && el.id_region === firstSelect.id_region && el.id_vcl_institution === firstSelect.id_vcl_institution);
      if(checkSameGroup){
        let data = {
          action: action,
          row_infos: this.rowInfos,
          user_infos: this.userInfos,
          project_name: this.projectName,
          platform_infos: this.platformInfos,
          selected_rows: this.selectedRows,
        }
        if(!this.selectedRows.some(row => row.total_page > 40)){
          this.apiService.queryData(config.master.ndapi.url +'/enovsky/web/project/create', data, this.userInfos['access_token']).subscribe((response:any)=>{
            this.helper.showToast(response.message);
            this.dialogRef.close(response);
            /* if(response.status){
              let contentsInfos = {
                platform_infos: this.platformInfos,
                user_infos: this.userInfos,
                id_project: response.id_project
              };
              const formData = new FormData();
              formData.append('data', JSON.stringify(contentsInfos));
              this.apiService.queryData(config.master.flapi.url + '/enovsky/extract_content', formData, this.userInfos['access_token']).subscribe((response:any)=>{
                
              });
            } */
          })
        }else this.helper.showToast('One or more contents have more than 40 pages...')
        
      }else this.helper.showToast('All the selections are not in the same Structure or Country - Cycle - Region - Institution')
      
    }
    if(action == 'delete_content'){
      if(action){
        let data = {
          action: action,
          row_infos: this.rowInfos,
          user_infos: this.userInfos,
          project_name: this.projectName,
          platform_infos: this.platformInfos,
          selected_rows: this.selectedRows,
        }
        this.apiService.queryData(config.master.ndapi.url +'/enovsky/web/raw-content/action', data, this.userInfos['access_token']).subscribe((response:any)=>{
          this.helper.showToast(response.message);
          if(response.status){
            this.dialogRef.close(response);
          }
        })
      }else this.helper.showToast('No action is specified...')
    }
    if(action == 'split_raw_content'){
      let data = {
        action: action,
        user_infos: this.userInfos,
        project_infos: null,
        platform_infos: this.platformInfos,
        selected_rows: this.selectedRows,
      }
      const formData = new FormData();
      formData.append('data', JSON.stringify(data));
      this.apiService.queryData(config.master.flapi.url + '/enovsky/split_raw_content', formData, this.userInfos['access_token']).subscribe((response:any)=>{
        this.helper.showToast(response.message); 
        this.dialogRef.close(response);
      }) 
    }
    if(this.userInfos['privilege'] >= 3 || ['create_project'].includes(action)){
      
    }else this.helper.showToast('No enough privileges for this action...')
    
    
  }
  switchAction(){
    console.log("Hey")
    this.actionMode = this.actionControl.value;
    console.log(this.actionMode)
  }
  close(){
    this.dialogRef.close();
  }
}
